export const GET_AWARDS = "GET_AWARDS";
export const SET_AWARDS = "SET_AWARDS";
export const REFRESH_AWARDS = 'REFRESH_AWARDS';

